import SelectJob from './SelectJob';

export default SelectJob;
